import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Input } from '@/kaya';
import { iconConstants, routesConstants } from '@/constants';
import Icons from '@/icons';
import { generalHelpers } from '@/helpers';
import { userActions } from '@/actions';
import logo from '@/assets/upperLogin-image.png';

import styles from './ForgotPassword.module.scss';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = React.useState<{ [key: string]: string }>({
    email: '',
  });

  const handleResetPassword = async () => {
    const error = {
      email: generalHelpers.validateEmail(email),
    };
    if (!generalHelpers.isEmptyErrors(error)) {
      setErr(error);
      return;
    }
    setIsLoading(true);
    // write api call here
    const data = await userActions.forgotPasswordAction({ payload: { email } });
    if (data.success) {
      navigate(routesConstants.ROUTES.LOGIN);
    }
    setIsLoading(false);
  };

  return (
    <div className={styles.ForgotPassword}>
      <div className={styles.logo}>
        <img src={logo} alt="logo" className={styles.logoImg} />
      </div>
      <div className={styles.box}>
        <p className={styles.desc}>Forgot Password</p>
        <p className={styles.desc2}>Locked out? Let’s reset</p>

        <div className={styles.box1}>
          <Input
            type="email"
            placeholder="Email Address"
            className={styles.input}
            width="100%"
            value={email}
            onChange={(e) => setEmail(e)}
            errors={err}
            id="email"
            onEnterClick={handleResetPassword}
          />
          <Button
            className={styles.btn}
            onClick={handleResetPassword}
            type="Primary"
            isLoading={isLoading}
          >
            Reset Password
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
